import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from './error.service';
import { Router } from '@angular/router';
import { map, catchError, share } from 'rxjs/operators';
import { environment } from '@app/env';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class ApiClient {
  lang = environment.lang.split('_')[0];

  constructor(private http: HttpClient, private error: ErrorService, private router: Router) {}

  public execute(apiMethod: string, request: any): Observable<any> {
    if (!navigator.onLine) {
      this.router.navigate(['offline']);
    }
    return this.http.post(environment.ABSOLUTE_PATH + '/api/rpc/' + apiMethod + '?lang=' + this.lang, request).pipe(
      catchError(err => this.error.httpError(err)),
      share()
    );
  }

  public uploadFile(smallImage: File, largeImage: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('IMAGE_SQUARE', smallImage);
    formData.append('IMAGE_ORIGINAL', largeImage);
    return this.http.post('/api/uploadImage', formData).pipe(
      catchError(err => this.error.httpError(err)),
      share()
    );
  }
}
